import type { WorksheetQueryOptions } from './worksheetQueryBuilder'
import type { WorksheetSpecV1 } from './spec'
import { compileWorksheetQuery } from './worksheetQueryBuilder'
import type { WorksheetCompilation, WorksheetQueryExecution } from './worksheetQueryArtifacts'

export type WorksheetLoweredRelationBinding = {
  worksheetSpec: WorksheetSpecV1
  queryOptions: WorksheetQueryOptions & { emitExecPlan?: boolean; collectExecPlan?: boolean }
}

export const lowerWorksheetRelationBinding = (
  worksheetSpec: WorksheetSpecV1,
  queryOptions: WorksheetQueryOptions & { emitExecPlan?: boolean; collectExecPlan?: boolean },
): WorksheetLoweredRelationBinding => ({
  worksheetSpec,
  queryOptions,
})

export const lowerWorksheetAggregateBase = (
  relationBinding: WorksheetLoweredRelationBinding,
): WorksheetCompilation => compileWorksheetQuery(
  relationBinding.worksheetSpec,
  relationBinding.queryOptions,
)

export const lowerWorksheetCompilationToExecution = (
  compilation: WorksheetCompilation,
  queryOptions: WorksheetQueryOptions & { emitExecPlan?: boolean; collectExecPlan?: boolean },
): WorksheetQueryExecution => {
  const plan = compilation.execPlan
  if (Boolean((queryOptions as any)?.emitExecPlan) && plan && Array.isArray(plan.statements) && typeof plan.finalSql === 'string') {
    return { kind: 'plan', sql: plan.finalSql, plan, compilation }
  }
  return { kind: 'sql', sql: compilation.finalSql, compilation }
}
